
export class EmployeeFreebieModel {
    employeeFreebieId: number;
    employeeCode: string;
    freebieCode: string;
    username: string;
    freebieCount: number;
    year: number;
    month: number;
    maxConsumptionPerDay: number;
    employeeId: number
    freebieId: number;
    avlFreebie: number; 
    isActive: boolean; 

    // this field will should be a part of the request object

    /**
     * 
     * @param employeeFreebieId 
     * @param employeeCode 
     * @param freebiesId 
     * @param username 
     * @param freebiesCount 
     * @param year 
     * @param month 
     * @param maxConsumptionPerDay 
     * @param employeeId
     * @param freebiesId
     * @param consumedFreebie
     */
    constructor(employeeFreebieId: number,employeeCode: string,freebieCode: string,username: string,freebieCount: number,year: number,month: number,maxConsumptionPerDay: number, employeeId: number, freebieId: number, avlFreebie: number,isActive:boolean) {
        this.employeeFreebieId = employeeFreebieId;
        this.employeeCode = employeeCode;
        this.freebieCode = freebieCode;
        this.username = username;
        this.freebieCount = freebieCount;
        this.year = year;
        this.month = month;
        this.maxConsumptionPerDay = maxConsumptionPerDay;
        this.employeeId = employeeId;
        this.freebieId = freebieId;
        this.avlFreebie = avlFreebie;
        this.isActive= isActive;
    }
}
